module.exports = __webpack_public_path__ + "media/audio96.ee06ca9f.mp3";